// extracted by mini-css-extract-plugin
module.exports = {"container":"UserMenu_container__c6co9"};